'use client';

import styles from './hero.module.css';
import { useTranslations } from 'next-intl';

export default function Hero() {
  const t = useTranslations('EventPage');

  return (
    <section className={styles.heroSection}>
      <div className={styles.heroOverlay}>
        <h1 className={styles.heroTitle}>{t('title')}</h1>
      </div>
    </section>
  );
}
